import { Flex } from '@chakra-ui/react';

import { InputV2 } from 'uiToolkitV1/InputV2';
import { Radio } from 'uiToolkitV1/Radio';

import { EngagementAnswerOptions } from '../slice/AddEngagementQuestion.slice';

type ScaleQuestionProps = {
  answerOptions?: EngagementAnswerOptions; // Array of descriptions for each scale value
  onDescriptionChange: (index: number, value: string) => void; // Callback for description changes
};

const ChoiceBasedScale = ({ answerOptions = [], onDescriptionChange }: ScaleQuestionProps) => (
  <Flex flexDirection="column" gap="16px">
    {/* Scale Row */}
    <Flex flexDirection="column" gap="8px" w="100%">
      {answerOptions.map(({ description, score }, i) => (
        <Flex key={score} alignItems="center" gap="16px" w="100%">
          <Radio name="dummy" onChange={undefined} />
          {/* Description Input */}
          <InputV2
            isDashed
            placeholder="Enter label"
            value={description ?? ''}
            onChange={(e) => onDescriptionChange(i, e.target.value)}
            style={{ width: '100%' }}
          />
        </Flex>
      ))}
    </Flex>
  </Flex>
);

export { ChoiceBasedScale };
